.root {
  position: fixed;
  inset: 0;
  z-index: 60;
}

.scrim {
  position: absolute;
  inset: 0;
  background: var(--scrim);
}

.panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-left: 1px solid var(--line);
  background: var(--panel);
  box-shadow: var(--shadow-drawer);
}

.panel:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
}

.sm {
  max-width: 360px;
}

.md {
  max-width: 450px;
}

.lg {
  max-width: 640px;
}

.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--line);
}

.heading {
  min-width: 0;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 650;
  letter-spacing: -0.01em;
  overflow-wrap: anywhere;
}

.description {
  margin: 3px 0 0;
  color: var(--muted);
  font-size: var(--t-dense);
}

.close {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: var(--target-min);
  height: var(--target-min);
  padding: 0;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: var(--muted);
  cursor: pointer;
}

.close:hover {
  background: var(--panel-3);
  color: var(--ink);
}

.body {
  flex: 1;
  min-height: 0;
  padding: 16px 20px;
  overflow-y: auto;
}

.footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 20px;
  border-top: 1px solid var(--line);
  background: var(--panel-2);
}

@media (width <= 900px) {
  .close {
    width: var(--target-touch);
    height: var(--target-touch);
  }
}
